import InitialState from 'Site/State/InitialState';

const PublicApp = (state = InitialState, { type, payload } = {}) => {
  if (!state) return InitialState;
  switch (type) {
    case 'LOADED_SITE_DATA': {
      const { meta, blogs, pages } = payload;
      const ui = {
        ...state.ui,
        siteLoading: false,
        siteBroken: false
      };
      return { ...state, meta, blogs, pages, ui };
    }
    case 'FATAL_ERROR': {
      const { message } = payload;
      const ui = {
        ...state.ui,
        siteLoading: false,
        siteBroken: true,
        errorMessage: message
      };
      return { ...state, ui };
    }
    case 'SET_SITE_META': {
      const { meta } = payload;
      return { ...state, meta };
    }
    case 'SET_SITE_PAGES': {
      const { pages } = payload;
      return { ...state, pages };
    }
    case 'SET_SITE_BLOGS': {
      const { blogs } = payload;
      return { ...state, blogs };
    }
    default:
      return state;
  }
};

export default PublicApp;



// WEBPACK FOOTER //
// ./client/Site/State/App.js